const googleTagManager = (gtmId) => `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;

const injectGoogleTagManager = (gtmId) => {
  if (window && typeof window === 'object' && window.document) {
    const { document } = window;
    const head = document.head || document.getElementsByTagName('head')[0];
    window.dataLayer = [];
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = googleTagManager(gtmId);
    head.appendChild(scriptElement);
  }
};

export default injectGoogleTagManager;
